/* HeyMara — cart page: qty steppers + remove via /cart/change.js, then reload
   (server re-renders prices/totals with correct currency formatting). */
(function () {
  "use strict";

  function init() {
    var section = document.querySelector("[data-cart-page]");
    if (!section || section.dataset.hmBound) return;
    section.dataset.hmBound = "1";

    function change(line, qty) {
      section.classList.add("is-loading");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { section.classList.remove("is-loading"); });
    }

    [].slice.call(section.querySelectorAll(".cp-line")).forEach(function (row) {
      var line = parseInt(row.getAttribute("data-line"), 10);
      var span = row.querySelector(".cp-qty span");
      var cur = span ? parseInt(span.textContent, 10) || 0 : 0;
      [].slice.call(row.querySelectorAll(".cp-qty button[data-step]")).forEach(function (b) {
        b.addEventListener("click", function () {
          change(line, Math.max(0, cur + (parseInt(b.getAttribute("data-step"), 10) || 0)));
        });
      });
      var rm = row.querySelector("[data-remove]");
      if (rm) rm.addEventListener("click", function () { change(line, 0); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
